import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSecurityStandards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m34 39 4 4 9-9m9 6c0 9.817-10.708 16.957-14.604 19.23-.443.258-.664.387-.977.454a2.3 2.3 0 0 1-.838 0c-.313-.067-.534-.196-.977-.454C34.708 56.957 24 49.817 24 40v-9.565c0-1.599 0-2.398.262-3.086a4 4 0 0 1 1.093-1.578c.552-.486 1.3-.767 2.798-1.328l10.723-4.022c.416-.156.624-.233.838-.264a2 2 0 0 1 .572 0c.214.03.422.108.838.264l10.723 4.022c1.497.561 2.246.842 2.798 1.328a4 4 0 0 1 1.093 1.578c.262.688.262 1.487.262 3.086z"
    />
  </svg>
);
export default SvgSecurityStandards;
